import { FulfillmentBoardWrapper } from '../../components'

export default function FulfillmentBoardPage() {
  return <FulfillmentBoardWrapper fullscreen />
}
